







































































































































import {
  Component,
  Prop,
  Mixins
} from "vue-property-decorator";
import AbpBase from "../../../lib/abpbase";
import columns from "./columnsDetail";
import DateTimeMixin from "@/components/mixin/date-time-mixin";
import Entity from "@/store/entities/entity";
import AppConsts from "@/lib/appconst";
import _ from "lodash";
import history from './history.vue'


class Filter extends Entity<number>{
    categoryId:number;
    clientCode:string;
    keyword:string;
}


@Component({
    components:{history}
})
export default class EditRole extends Mixins(AbpBase,DateTimeMixin) {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Number, default: null }) codeCurrent: any;
  @Prop({ type: Number, default: null }) id: any;
  @Prop({ type: Number, default: null }) productId: any;


  data: any = {
    name: '',
    note: '',
  };
  listAll: any = [];
  list: any = [];
  listView: any = [];
  clients: any = [];
  Filter: Filter = new Filter();
  categoriesOfClient: [] = [];
  pageSize: any = 10;
  currentPage: any = 1;
  selectModalShow:boolean=false;
  currentRow: any = [];

  historyView(row) {
    this.id = row.id;
    this.productId = row.productId;
    this.selectModalShow = true;
  }

  get loading(){
    return this.$store.state.warrantyDurationConfig.loading;
  }

  get totalCount(){
      return _.size(this.list);
  }
  
  pageChange(page:number){
    this.currentPage = page;
    this.setView(this.list);
  }

  pagesizeChange(pagesize:number){
    this.pageSize = pagesize;
    this.setView(this.list);
  }

  columns = columns;

  onFilter() {
    const values = this.Filter;
    let datas = this.listAll;
    if(!_.isEmpty(values.clientCode) && values.clientCode != '_ALL')
      datas = _.filter(datas, v => v.product.clientCode === values.clientCode)
    if(!_.isNil(values.categoryId) && values.categoryId != -1)
      datas = _.filter(datas, v => v.product.categoryId === values.categoryId)
    if(!_.isEmpty(values.keyword))
      datas = _.filter(datas, v => _.toUpper(v.product.sku).includes(_.toUpper(values.keyword) || _.toUpper(v.product.name).includes(_.toUpper(values.keyword))))    
    
    var index = 0;
    datas.forEach(function(item) {
      item.orderNo = index + 1;
      index++;
    });
    this.list = datas;
    this.setView(datas);
  }

  cancel() {
    this.$emit("input", false);
  }

  visibleChange(value: boolean) {
    this.Filter = new Filter();
    if (!value) {
      this.$emit("input", value);
    } else {
      this.getpage();
    }
  }

  async getpage(){  
      await this.$store.dispatch({
          type:'warrantyDurationConfig/get',
          data: {
          id: this.codeCurrent,
        },
      }).then(v => { 
        this.data = v;
        this.currentPage = 1;
        this.pageSize = 10;
        var re = this.data.warrantyDurationConfigs;
        var startIndex = (this.currentPage - 1) * this.pageSize;
        var index = 0;
        re.forEach(function(item) {
          item.orderNo = startIndex + index + 1;
          index++;
        });
        this.listAll = re;
        this.list = re;
        this.setView(re);
      })
  }

  setView(result) {
    const start = this.currentPage * this.pageSize - this.pageSize;
    const end = start + this.pageSize - 1;
    this.listView = _.filter(result,(item, index) => index >= start && index <= end);
  }

  async changeClientCode() {
    await this.getCategoriesOfClientForSelect();
  }

  async getCategoriesOfClientForSelect() {
    await this.$store
      .dispatch({
        type: "category/getCategoriesByClientForSelect",
        data: { clientCode: this.Filter.clientCode },
      })
      .then(() => {
        var re = this.$store.state.category.categoriesOfClientForSelect;
        re.unshift({ id: -1, name: this.L(AppConsts.All) });
        this.categoriesOfClient = re;
        this.Filter.categoryId = -1;
      });
  }
  async created(){
    this.getClients();
  }

  async getClients() {
    await this.$store
      .dispatch({
        type: "client/getListForSelect",
        data: { hasAllItem: true },
      })
      .then(() => {
        this.clients = this.$store.state.client.clientsForSelect;
      });
  }
}
